module.exports = __webpack_public_path__ + "img/kino_kunsthalle_3_a.84d3f281.jpg";